import MainCard from 'components/MainCard';
import { NotificationsTable } from 'components/tables/NotificationsTable';
import { INotification } from 'models/INotification';
import { IUser } from 'models/IUser';

interface NotificationsTabProps {
  notifications: INotification[];
  users: IUser[];
  isSingleUser: boolean;
  isLoading: boolean;
  isFetching: boolean;
}

export default function NotificationsTab({ notifications, users, isSingleUser, isLoading, isFetching }: NotificationsTabProps) {
  return (
    <MainCard content={false}>
      <NotificationsTable
        notifications={notifications}
        users={users}
        isSingleUser={isSingleUser}
        isLoading={isLoading}
        isFetching={isFetching}
      />
    </MainCard>
  );
}